import { Props } from 'shared/blocks/html/components/Html';

export default (content: Props): Props => content;
